// This code handles all the data changes in the app regarding incentive store

/**
 * Even though the store is split in different files every reducer needs
 * this to return StoreModel since all the store are merged in one
 */
import { getInitialState } from '../initial-state';
import { IncentiveStoreModel } from '../../typings/incentive-store';
import { OptionsProps } from '../../../typings/general';
import { StoreModel } from '../../typings/store';

/**
 * Here are all the reducer functions for Incentive store
 */
export function getReducer(): any {
  return {
    /**
     * Set initial data used for this app
     */
    SET_INITIAL_DATA: () => {
      return getInitialState();
    },
    /**
     * Update store by form input values
     * @param currentState Previous state
     * @param form Form input
     */
    UPDATE_STORE_BY_FORM_INPUT: (
      currentState: StoreModel,
      { form }: IncentiveStoreModel,
    ) => {
      return {
        ...currentState,
        form,
        formValidationError: {
          model: false,
          modelYear: false,
          trim: false,
          mileage: false,
          vin: false,
        },
      };
    },
    /**
     * Update store by form input values
     * @param currentState Previous state
     * @param formValidationError Form input errors
     * @param status Status on either the form was submitted or not
     */
    VALIDATE_FORM: (
      currentState: StoreModel,
      { status, formValidationError }: IncentiveStoreModel,
    ) => {
      return {
        ...currentState,
        status,
        formValidationError,
      };
    },
    /**
     * Add model years to store
     * @param currentState Previous state
     * @param modelYears Array of the model years returned from the services
     */
    SET_MODEL_YEARS: (
      currentState: StoreModel,
      { modelYears }: IncentiveStoreModel,
    ) => {
      const formattedModelYear: OptionsProps[] = [];
      modelYears.forEach((year) =>
        formattedModelYear.push({
          value: year.value,
          label: year.value,
        }),
      );
      return {
        ...currentState,
        modelYears: formattedModelYear,
      };
    },
    /**
     * Updated the store with the information for the <ModelCard />
     * @param currentState Previous state.
     * @param currentData the data that the user selects on the form
     */
    SET_MODEL_CARD_DATA: (
      currentState: StoreModel,
      { currentData }: IncentiveStoreModel,
    ) => {
      return {
        ...currentState,
        currentData: { ...currentState.currentData, ...currentData },
      };
    },
    /**
     * Update the store with the vehicle's information fetch from the API
     */
    SET_VEHICLE_DATA: (
      currentState: StoreModel,
      { vehicle }: IncentiveStoreModel
    ) => {
      return {
        ...currentState,
        vehicle,
      }
    }
  };
}
